// extracted by mini-css-extract-plugin
export default {"form":"SearchInput_form__VJNt2","field":"SearchInput_field__53Krx"};